<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
</script>

<style lang='scss'>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
ul {
  list-style: none;
}
th {
  font-weight: normal;
}
a {
  text-decoration: none;
}
::-webkit-scrollbar-track {
  border-radius: 2px;
  background: rgba(128, 133, 144, 0.06);
}
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: rgba(128, 133, 144, 0.15);
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-button {
  display: block;
  width: 0;
  height: 0;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  padding: 0;
}
.hr {
  width: 100%;
  margin: 15px auto;
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
}
.hr2 {
  width: 80%;
  margin: 0 auto;
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.hr3 {
  width: 80%;
  margin: 0 auto;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

/*!
Base.css - http://www.qiyizm.com
Copyright (c) 2019 QYZM
*/
.m-64 {
  margin: 64px;
}

.mt-64 {
  margin-top: 64px;
}

.mr-64 {
  margin-right: 64px;
}

.mb-64 {
  margin-bottom: 64px;
}

.ml-64 {
  margin-left: 64px;
}

.m-32 {
  margin: 32px;
}

.mt-32 {
  margin-top: 32px;
}

.mr-32 {
  margin-right: 32px;
}

.mb-32 {
  margin-bottom: 32px;
}

.ml-32 {
  margin-left: 32px;
}

.m-16 {
  margin: 16px;
}

.mt-16 {
  margin-top: 16px;
}

.mr-16 {
  margin-right: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.ml-16 {
  margin-left: 16px;
}

.m-8 {
  margin: 8px;
}

.mt-8 {
  margin-top: 8px;
}

.mr-8 {
  margin-right: 8px;
}

.mb-8 {
  margin-bottom: 8px;
}

.ml-8 {
  margin-left: 8px;
}

.p-64 {
  padding: 64px;
}

.pt-64 {
  padding-top: 64px;
}

.pr-64 {
  padding-right: 64px;
}

.pb-64 {
  padding-bottom: 64px;
}

.pl-64 {
  padding-left: 64px;
}

.p-32 {
  padding: 32px;
}

.pt-32 {
  padding-top: 32px;
}

.pr-32 {
  padding-right: 32px;
}

.pb-32 {
  padding-bottom: 32px;
}

.pl-32 {
  padding-left: 32px;
}

.p-16 {
  padding: 16px;
}

.pt-16 {
  padding-top: 16px;
}

.pr-16 {
  padding-right: 16px;
}

.pb-16 {
  padding-bottom: 16px;
}

.pl-16 {
  padding-left: 16px;
}

.p-8 {
  padding: 8px;
}

.pt-8 {
  padding-top: 8px;
}

.pr-8 {
  padding-right: 8px;
}

.pb-8 {
  padding-bottom: 8px;
}

.pl-8 {
  padding-left: 8px;
}

/* ================================
Components
Navigation
================================= */
.navigation {
  width: 100%;
  min-height: 64px;
  position: fixed;
  top: 0;
  background-color: black;
  color: white;
}

.navigation-logo {
  float: left;
  margin-top: 20px;
  color: white;
  text-decoration: none;
  font-size: 27px;
  line-height: 22px;
}

.logo-icon {
  display: inline-block;
  background-image: url(https://~.png);
  background-repeat: no-repeat;
  background-position: -120px 0px;
  width: 90px;
  height: 23px;
}

.navigation-left {
  float: left;
  margin: 0;
}

.navigation-left > li {
  display: inline-block;
  margin: 22px 10px;
  vertical-align: middle;
}

.navigation-left > li > a {
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  color: #efefef;
}

.navigation-left > li > a:hover {
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  color: #dedede;
}

.navigation-left .active {
  color: white;
}

.navigation-left .active a {
  color: white;
}

.navigation-left .active a:hover {
  color: white;
}

.navigation-right {
  float: right;
  margin: 0;
}

.navigation-right > li {
  display: inline-block;
  margin: 16px 10px;
  vertical-align: middle;
}

.navigation-right > li > a {
  font-size: 14px;
  text-decoration: none;
  color: #c0c0c0;
  opacity: 0.6;
}

.navigation-right > li > a:hover {
  font-size: 14px;
  text-decoration: none;
  color: #dedede;
  opacity: 0.9;
}

.nav-right-icon-1 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -260px 0px;
  width: 22px;
  height: 23px;
}

.nav-right-icon-2 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -300px 0px;
  width: 30px;
  height: 23px;
}

.nav-right-icon-3 {
  display: inline-block;
  z-index: -2;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  opacity: 1;
  vertical-align: middle;
  margin-right: 5px;
}

.nav-right-icon-4 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -20px -40px;
  width: 9px;
  height: 6px;
}

/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}
.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

/* ================================
Components
Menu
================================= */
.menu-ul {
  display: none;
  position: absolute;
  top: 60px;
  z-index: 600;
  width: 110px;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 15px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 1px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 1px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
}

.menu-li {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #dbdbdb;
  cursor: pointer;
  opacity: 0.8;
}

.menu-li:hover {
  background-color: #f5f5f5;
  border-radius: 3px;
}

.icon {
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
}

.icon-user {
  float: left;
  margin-top: 2px;
  margin-left: 10px;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: 0px -60px;
  opacity: 0.8;
}

/* ================================
Components
BgMask
================================= */
.bgmask {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0px;
  background-color: gray;
  opacity: 0.9;
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  filter: alpha(opacity = 50);
  z-index: 3;
}

/* ================================
Components
PopUp
================================= */
.popup {
  display: none;
  position: fixed;
  top: 40%;
  left: 50%;
  width: 450px;
  margin: 0 auto;
  vertical-align: middle;
  text-align: center;
  color: #333;
  font-size: 14px;
  background-color: white;
  border-radius: 4px !important;
  box-shadow: 0px 10px 30px rgba(34, 25, 25, 0.2);
  transform: translateX(-50%) translateY(-50%);
  /* opacity: 0.95; */
  z-index: 5;
}

.popup-head {
  margin-top: 10px;
  height: 15px;
}

.popup-head .head-left {
  margin-left: 15px;
  float: left;
}

.popup-head .head-right {
  margin-right: 15px;
  float: right;
}

.popup-close {
  cursor: pointer;
}

.popup-body {
  margin-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  background-color: #ececec;
  text-align: left;
}

.popup-container {
  padding: 10px;
  background-color: white;
  vertical-align: middle;
}

/* ================================
Components
Tip
================================= */
.ui-tip {
  display: none;
  width: 100px;
  height: auto;
  padding-top: 8px;
  padding-bottom: 8px;
  margin: 0 auto;
  position: fixed;
  top: 40%;
  left: 50%;
  z-index: 5;
  font-size: 15px;
  font-weight: bolder;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0px 10px 30px rgba(34, 25, 25, 0.2);
  transform: translateX(-50%) translateY(-50%);
  opacity: 0.95;
}

.ui-tip-arrow::before,
.ui-tip-arrow::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0px;
  border-width: 5px;
  border-style: solid;
}

.ui-tip-arrow.ui-tip-arrow-up::after {
  border-left-color: transparent;
  border-top-color: transparent;
  bottom: 100%;
  right: 20%;
}

.ui-tip-arrow.ui-tip-arrow-up::before {
  border-right-color: transparent;
  border-top-color: transparent;
  bottom: 100%;
  left: 80%;
}

.ui-theme-white {
  color: black;
}

.ui-theme-white::after,
.ui-theme-white::before {
  border-color: white;
}

.ui-theme-black {
  background-color: rgba(48, 48, 48, 1);
  color: white;
}

.ui-theme-black::after,
.ui-theme-black::before {
  border-color: rgba(48, 48, 48, 1);
}

/* ================================
Components
IMG wrapper
================================= */
.img-wrapper {
  margin: 30px 10px;
  cursor: pointer;
}

/* ================================
Components
CheckBox RadioBox wrapper
================================= */
.cbrb-wrapper {
  margin: 8px auto;
  vertical-align: text-bottom;
}

/* ================================
Components
HR
================================= */
.hr-001 {
  width: 50%;
  margin: 15px auto;
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
}

.hr-002 {
  width: 50%;
  margin: 60px auto;
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.hr-003 {
  width: 50%;
  margin: 0 auto;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

/* ================================
Components
Link Button
================================= */
.link-btn {
  display: inline-block;
  padding: 13px 23px;
  color: white;
  font-size: 22px;
  background-color: black;
  border-radius: 3px;
  border: 0px;
}

.link-btn:hover {
  background-color: #3da7e7;
  transition-property: background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  -webkit-transition-property: background-color;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-timing-function: ease;
}

/* ================================
Components
Submit Button
================================= */
.sub-btn {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 40px;
  color: white;
  font-size: 14px;
  background-color: #929aea;
  border-radius: 3px;
  border: 0px;
}

.sub-btn:hover {
  background-color: #4253ff;
  transition-property: background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  -webkit-transition-property: background-color;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-timing-function: ease;
}

/* ================================
Components
List No
================================= */
.list-no {
  font: 44px/44px Georgia;
  color: #f85959;
}

/* ================================
Components
Back to top button
================================= */
.bak-to-top-icon {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -18px -415px;
  width: 22px;
  height: 23px;
  vertical-align: bottom;
}

.back-to-top {
  background: #000000;
  color: #fff;
}

.back-to-top:focus {
  background: #2492ff;
  color: #fff;
}

.back-to-top:hover {
  background: #019090;
  color: #fff;
}

.back-to-top {
  position: fixed;
  display: none;
  padding: 6px 12px 9px 12px;
  font-size: 16px;
  border-radius: 2px;
  right: 15px;
  bottom: 15px;
  transition: background 0.5s;
  z-index: 1000;
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 15px;
  }
}

.back-to-top:focus {
  outline: none;
}

/* ================================
Layout
================================= */
.section {
  width: 100%;
  min-height: 64px;
  /* border: dashed 1px #808080; */
  padding-top: 40px;
  padding-bottom: 40px;
}

.container-940 {
  width: 940px;
  min-height: 64px;
  margin: 0 auto;
  /* border: dashed 1px #808080; */
}

.container-1170 {
  width: 1170px;
  min-height: 64px;
  margin: 0 auto;
  /* border: dashed 1px #808080; */
}

.columns {
  min-height: 64px;
  /* border: dashed 1px #808080; */
  overflow: hidden;
}

.columns-head {
  text-align: center;
}

.columns-foot {
  text-align: center;
}

.columns .column-2 {
  float: left;
  width: 50%;
  min-height: 64px;
}

.columns .column-3 {
  float: left;
  width: 33.33%;
  min-height: 64px;
}

.columns .column-4 {
  float: left;
  width: 25%;
  min-height: 64px;
}

.columns .column-5 {
  float: left;
  width: 20%;
  min-height: 64px;
}

.columns .column-2-pct20 {
  float: left;
  width: 20%;
  min-height: 64px;
}

.columns .column-2-pct30 {
  float: left;
  width: 30%;
  min-height: 64px;
}

.columns .column-2-pct40 {
  float: left;
  width: 40%;
  min-height: 64px;
}

.columns .column-2-pct60 {
  float: left;
  width: 60%;
  min-height: 64px;
}

.columns .column-2-pct70 {
  float: left;
  width: 70%;
  min-height: 64px;
}

.columns .column-2-pct80 {
  float: left;
  width: 80%;
  min-height: 64px;
}

.columns .column-3-pct25 {
  float: left;
  width: 25%;
  min-height: 64px;
}

.columns .column-3-pct50 {
  float: left;
  width: 50%;
  min-height: 64px;
}

/* ================================
Flex布局
.item {flex: none;}
等同
.item {
flex-grow: 0;
flex-shrink: 0;
flex-basis: auto;
}

.item {flex: auto;}
等同.item {
flex-grow: 1;
flex-shrink: 1;
flex-basis: auto;
}

.item {flex: 1;}
等同
.item {flex-grow: 1; flex-shrink: 1; flex-basis: 0%;}
================================= */
.row {
  display: flex;
}

.col {
  flex: 1;
}

/* ================================
Typography
================================= */
.text-aligh-left {
  text-align: left;
}

.text-aligh-center {
  text-align: center;
}

.font-style-italic {
  font-style: italic;
}

.font-style-normal {
  font-style: normal;
}

.font-weight-bolder {
  font-weight: bolder;
}

.font-weight-bold {
  font-weight: bold;
}

.font-weight-normal {
  font-weight: normal;
}

.font-weight-lighter {
  font-weight: lighter;
}

.font-size-40 {
  font-size: 40px;
}

.font-size-36 {
  font-size: 36px;
}

.font-size-14 {
  font-size: 14px;
}

.font-size-12 {
  font-size: 12px;
}

.line-height-pct150 {
  line-height: 150%;
}

.line-height-pct200 {
  line-height: 200%;
}

.underline {
  text-decoration: underline;
}

.linethrough {
  text-decoration: line-through;
}

.color-pink {
  color: #ff6382;
}

.color-black {
  color: #000000;
}

.color-black-2f2f2f {
  color: #2f2f2f;
}

.color-white {
  color: white;
}

.color-white-e4e8eb {
  color: #e4e8eb;
}

.color-white-39596 {
  color: #303133;
}

.color-primary-text {
  color: #303133;
}

.color-regular-text {
  color: #606266;
}

.color-secondary-text {
  color: #909399;
}

.color-placeholder-text {
  color: #C0C4CC;
}

.color-brand-1 {
  color: #337ecc;
}

.color-brand-2 {
  color: #53a8ff;
}

.color-brand-3 {
  color: #66b1ff;
}

.color-brand-4 {
  color: #79bbff;
}

.color-brand-5 {
  color: #8cc5ff;
}

.color-border-1 {
  color: #DCDFE6;
}

.color-border-2 {
  color: #E4E7ED;
}

.color-border-3 {
  color: #EBEEF5;
}

.color-border-4 {
  color: #F2F6FC;
}

/* ================================
Background
================================= */
.bg-transparent {
  background-color: transparent;
}

.bg-green-49cc97 {
  background-color: #66d5a8;
}

.bg-green-3e5c50 {
  background-color: #3e5c50;
}

.bg-blue-dde7ed {
  background-color: #dde7ed;
}

.bg-blue-a1bfd4 {
  background-color: #a1bfd4;
}

.bg-black-2b2c2e {
  background-color: #2b2c2e;
}

.bg-gray-ececec {
  background-color: #ececec;
}

.bg-gray-808080 {
  background-color: #808080;
}

.bg-white-ffffff {
  background-color: #ffffff;
}

.bg-black-000000 {
  background-color: #000000;
}

/* ================================
Border
================================= */
.border-001 {
  border: solid 1px black;
}

.border-002 {
  border: dashed 1px #808080;
}

.border-radius-001 {
  border-radius: 3px;
}

.left-border-001 {
  border-left: solid 1px gray;
}

/* ================================
Shadows
================================= */
.shadows-001 {
  box-shadow: 0 23px 68px rgba(31, 31, 31, 0.25),
    0 0 0 1px rgba(31, 31, 31, 0.15);
}

.shadows-002 {
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 1px rgba(31, 31, 31, 0.15);
}

/* ================================
Transitions & Transforms
================================= */
.bg-color-transition {
  transition-property: background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  -webkit-transition-property: background-color;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-timing-function: ease;
}

/* ================================
Effects
================================= */
.cursor-pointer {
  cursor: pointer;
}

/* ================================
Icons
================================= */
.yes-icon {
  display: inline-block;
  // background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -315px -35px;
  width: 22px;
  height: 23px;
  vertical-align: middle;
}

.no-icon {
  display: inline-block;
  // background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -355px -35px;
  width: 22px;
  height: 23px;
  vertical-align: middle;
}

.limit-icon {
  display: inline-block;
  // background-image: url(../images/limit.png);
  background-repeat: no-repeat;
  width: 22px;
  height: 23px;
  vertical-align: middle;
}

/* ================================
Absolute div
================================= */
.absolute-div {
  position: absolute;
  // left:200px;
  padding: 0;
  margin: 0;
  color: gray;
  font-size: 12px;
  border-radius: 3px;
  list-style: none;
  overflow: auto;
}

.absolute-div-left {
  left: 200px;
}

/* ================================
Ariticle
================================= */
.ariticle {
  padding: 40px;
  overflow: auto;
}

.ariticle-title {
  font-size: 26px;
  font-weight: bold;
}

.ariticle-subtitle {
  font-size: 14px;
  color: gray;
  padding-top: 20px;
}

.ariticle-content {
  font-size: 18px;
  color: rgb(88, 88, 88);
  padding-top: 20px;
  line-height: 30px;
}

.ariticle-banner {
  padding-top: 50px;
}

.ariticle-foot {
  padding-top: 50px;
}

/* ================================
Panel
================================= */
.panel {
  position: relative;
  padding: 10px 20px 10px 20px;
  border-bottom: 1px solid rgb(240, 240, 240);
  overflow: hidden;
}

.panel:hover {
  cursor: pointer;
  .panel-title {
    color: #5ab1eb;
    transition-property: color;
    transition-duration: 0.3s;
    transition-timing-function: ease;
    -webkit-transition-property: color;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease;
  }
}

.panel-image-right {
  width: 90px;
  height: 90px;
  float: right;
  padding-left: 10px;
}

.panel-image-left {
  width: 90px;
  height: 90px;
  float: left;
  padding-right: 10px;
}

.panel-title {
  font-size: 18px;
  color: #303133;
  padding-bottom: 5px;
}

.panel-tag {
  display: flex;
  font-size: 12px;
  color: #909399;
  padding-bottom: 7px;
}

.panel-footer {
  /* position: absolute;
    bottom: 0;
    left: 0;
    padding-bottom: 5px;
    padding-left: 10px; */
  display: flex;
  font-size: 12px;
  color: gray;
  overflow: hidden;
  vertical-align: middle;
  height: 40px;
  line-height: 40px;
}

.view2row {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
